import { render, staticRenderFns } from "./ConcoursCibles.vue?vue&type=template&id=28fa44c5&scoped=true"
import script from "./ConcoursCibles.vue?vue&type=script&lang=js"
export * from "./ConcoursCibles.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=28fa44c5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa44c5",
  null
  
)

export default component.exports